import BACK from "../assets/back.png";
import COMMENT from "../assets/comment.svg";

export default {
    BACK,
    COMMENT
};



// WEBPACK FOOTER //
// ./src/icons/icons.js